import React from 'react';

import { SimpleAmountSelector } from './components/AmountSelector/SimpleAmountSelector';
import { ValidationError } from './components/ValidationError';
import { useImpressionAmountSelector } from './hooks/useImpressionAmountSelector';

export const ImpressionAmountSelector: React.FC<EmptyProps> = () => {
	const {
		data: { ref },
	} = useImpressionAmountSelector();

	return (
		<div data-testid="promotion-impression-amount-selector" ref={ref} className="flex flex-col gap-4">
			<ValidationError />
			<SimpleAmountSelector />
		</div>
	);
};
